export default "70e898ee1d167882931773b8d99509c1.png";